import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWifiWeak: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wifi-weak, spot, signal, hot spot"><path d="M6.75 13.3144C9.812 10.9264 14.187 10.9264 17.249 13.3144" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M12 18.25C12.4142 18.25 12.75 18.5858 12.75 19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19C11.25 18.5858 11.5858 18.25 12 18.25Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/></CentralIconBase>;
};

export default IconWifiWeak;
